import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { supabase } from '../services/supabase';

const Header = ({ cartCount }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [settings, setSettings] = useState({
    storeName: 'IWantCheats',
    logoUrl: ''
  });
  const location = useLocation();

  useEffect(() => {
    loadSettings();
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close menu on route change
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const loadSettings = async () => {
    try {
      const { data } = await supabase
        .from('store_settings')
        .select('store_name, logo_url, page_title, favicon_url')
        .limit(1)
        .single();
      if (data) {
        setSettings({
          storeName: data.store_name || 'IWantCheats',
          logoUrl: data.logo_url || ''
        });
        if (data.page_title) document.title = data.page_title;
        if (data.favicon_url) {
          let link = document.querySelector("link[rel~='icon']");
          if (!link) {
            link = document.createElement('link');
            link.rel = 'icon';
            document.head.appendChild(link);
          }
          link.href = data.favicon_url;
        }
      }
    } catch (err) {
      // ignore
    }
  };

  const isActive = (path) => location.pathname === path ? 'active' : '';

  return (
    <>
      <header className={`site-header${scrolled ? ' scrolled' : ''}`}>
        <div className="header-container">
          {/* Logo */}
          <Link to="/" className="logo">
            {settings.logoUrl && (
              <img src={settings.logoUrl} alt={settings.storeName} className="logo-image" />
            )}
            <span className="store-name">{settings.storeName}</span>
          </Link>

          {/* Desktop Nav */}
          <nav className="desktop-nav">
            <Link to="/" className={isActive('/')}>Home</Link>
            <a href="/#products">Products</a>
            <Link to="/status" className={isActive('/status')}>
              <span className="nav-status-badge">
                <span className="nav-status-dot"></span>
                Status
              </span>
            </Link>
            <Link to="/track-order" className={isActive('/track-order')}>Track Order</Link>
            <Link to="/wishlist" className={isActive('/wishlist')}>Wishlist</Link>
            <Link to="/about" className={isActive('/about')}>About</Link>
            <Link to="/contact" className={isActive('/contact')}>Contact</Link>
            <Link to="/admin" className={`admin-link ${isActive('/admin')}`}>Admin</Link>
          </nav>

          {/* Cart + Hamburger */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <Link to="/cart" className="cart-link" aria-label="Cart">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="8" cy="21" r="1"></circle>
                <circle cx="19" cy="21" r="1"></circle>
                <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"></path>
              </svg>
              {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
            </Link>

            <button
              className={`hamburger${menuOpen ? ' active' : ''}`}
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Toggle menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </header>

      {/* Mobile overlay */}
      {menuOpen && <div className="menu-overlay" onClick={() => setMenuOpen(false)} />}

      {/* Mobile drawer */}
      <nav className={`main-nav${menuOpen ? ' open' : ''}`}>
        <button className="close-menu" onClick={() => setMenuOpen(false)}>✕</button>
        <Link to="/" onClick={() => setMenuOpen(false)} className={isActive('/')}>Home</Link>
        <a href="/#products" onClick={() => setMenuOpen(false)}>Products</a>
        <Link to="/status" onClick={() => setMenuOpen(false)} className={isActive('/status')}>
          <span className="nav-status-badge"><span className="nav-status-dot"></span> Status</span>
        </Link>
        <Link to="/track-order" onClick={() => setMenuOpen(false)} className={isActive('/track-order')}>Track Order</Link>
        <Link to="/wishlist" onClick={() => setMenuOpen(false)} className={isActive('/wishlist')}>Wishlist</Link>
        <Link to="/about" onClick={() => setMenuOpen(false)} className={isActive('/about')}>About</Link>
        <Link to="/contact" onClick={() => setMenuOpen(false)} className={isActive('/contact')}>Contact</Link>
        <Link to="/admin" onClick={() => setMenuOpen(false)} className={`admin-link ${isActive('/admin')}`}>Admin</Link>
      </nav>
    </>
  );
};

export default Header;
